import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils/styles';

const avatarVariants = cva(
  'rounded-full bg-background-blur-medium flex justify-center items-center shadow-glass-image-inner',
  {
    variants: {
      size: {
        large: 'size-20 typography-d1',
        default: 'size-11 typography-h3',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export interface AvatarProps
  extends React.ComponentProps<'div'>,
    VariantProps<typeof avatarVariants> {
  username?: string;
  hideUsername?: boolean;
}

const getUserInitials = (username?: string) => {
  return username ? username[0] : undefined;
};

export const Avatar = ({ size, username, className }: AvatarProps) => {
  const userInitials = getUserInitials(username);

  return (
    <div
      data-size={size}
      className={cn(
        'flex flex-col gap-2 data-[size=large]:gap-4 items-center',
        className,
      )}
    >
      <div className="rounded-full">
        <div className={avatarVariants({ size })}>
          <span className="text-transparent bg-clip-text bg-gradient-to-b from-[#009E82] via-50% via-[#2F5CFF] to-[#DA1C2C]">
            {userInitials}
          </span>
        </div>
      </div>

      <span
        data-size={size}
        className="text-secondary typography-caption1 data-[size=large]:typography-d2 font-normal"
      >
        {username}
      </span>
    </div>
  );
};
